var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((_vm.isFormActive ? 'hubspotFormActive' : 'hubspotFormInActive') + " "),attrs:{"id":"hubspotForm"}})}]

export { render, staticRenderFns }